module.exports = __webpack_public_path__ + "images/dog_alinasink-fd437375abd620392cf085c5a18d44c7.jpg";